import { useState } from "react"
import styles from "./index.module.scss"
import RcmpArrowDownSingleAccordion from "../../../assets/icons/ArrowDownSingleAccordion"
import RcmpArrowRightSingleAccordion from "../../../assets/icons/ArrowRightSingleAccordion"
import RcmpCardEllipsis from "../Ellipsis"

export default function RcmpSingleAccordionIcon(props) {
  const {
    children,
    oGetData,
    nCurrentId,
    index,
    fnSetId,
    aEllipsisOption,
    fnSetData,
    icon,
    ...rest
  } = props
  const [nAccordion, fnSetNAccordion] = useState(index)

  async function fnToggleAccordion(index, id) {
    if (index === nAccordion) return fnSetNAccordion(-1)
    fnSetNAccordion(index)
    await fnSetId?.(id)
  }
  if (nCurrentId === String(oGetData?.id)) return null

  return (
    <div className={styles.container} {...rest}>
      <div className={styles.accordionFaq}>
        <div key={index} className={styles.accordionItem}>
          <div className={styles.accordionOption}>
            <div
              className={styles.accordionFaqHead}
              onClick={() => fnToggleAccordion(index, oGetData?.acbl_nid)}
            >
              {icon}
              <p>{oGetData?.acbl_cname}</p>
              <div className={styles.accordionName}>
                <div
                  className={
                    nAccordion === index
                      ? styles.iconContainer
                      : `${styles.iconContainer} ${styles.active} `
                  }
                >
                  <RcmpArrowDownSingleAccordion fill={"#6CB6E3"} />
                </div>
              </div>
            </div>
            <div>
              <RcmpCardEllipsis
                fill={"#415364"}
                position={"right"}
                aOptions={aEllipsisOption}
                fnSetData={fnSetData}
                oDataItem={oGetData}
                size={"182px"}
              />
            </div>
          </div>
          <div
            className={
              nAccordion === index
                ? `${(styles.active, styles.accordionContent)}`
                : `${styles.inactive}`
            }
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}
